import { useState, useEffect, useCallback } from 'react';
import { api, tokenStorage } from '../api/client';

export function usePartsToReturn(shopId) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    if (!tokenStorage.getAccess() || !shopId) return;
    setLoading(true);
    setError(null);
    try {
      const result = await api.getPartsToReturn(shopId);
      setData(result);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [shopId]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { data, loading, error, refresh };
}

export function useTaskCounts(shopId) {
  const [counts, setCounts] = useState(null);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!tokenStorage.getAccess()) return;
    setLoading(true);
    try {
      const data = await api.getTaskCounts(shopId);
      setCounts(data);
    } catch {
      // Graceful degradation — tasks might not exist yet
      setCounts({ by_status: {}, assigned_to_me: 0, awaiting_verification: 0, total: 0 });
    } finally {
      setLoading(false);
    }
  }, [shopId]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { counts, loading, refresh };
}

export function useTasks(params) {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!tokenStorage.getAccess()) return;
    setLoading(true);
    try {
      const data = await api.listTasks(params || {});
      setTasks(data.tasks || []);
    } catch {
      setTasks([]);
    } finally {
      setLoading(false);
    }
  }, [JSON.stringify(params)]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { tasks, loading, refresh };
}
